module.exports = __webpack_public_path__ + "img/main.cc51739e.png";